import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

export default makeStyles((theme) => ({
  cart: {
    padding: theme.spacing(3, 0),
    border: `1px solid ${theme.palette.separator.main}`,
    borderRadius: theme.spacing(1),
    background: theme.palette.otherElementsBackground.main,
    color: theme.palette.contrastText.main,
  },
  image: {
    objectFit: "cover",
    display: "block",
  },
  imageButton: {
    borderRadius: theme.spacing(1),
    overflow: "hidden",
  },
  fileAttachmentRowRoot: {
    background: theme.palette.attachmentsBackground.main,
    borderRadius: "8px",
    border: `1px solid ${theme.palette.separator.main}`,
    paddingLeft: theme.spacing(2),
  },
  productDescription: {
    borderRadius: "8px",
    background: theme.palette.secondaryContrast.main,
    width: "100%",
    padding: theme.spacing(1.5, 2),
  },
  productContainer: {
    padding: theme.spacing(1, 0, 2),
    background: "transparent",
    borderBottom: `1px solid ${grey[300]}`,
    "&:last-child": {
      borderBottom: 0,
    },
  },
  product: {
    display: "flex",
    alignItems: "stretch",
    minHeight: 56,
  },
  productName: {
    maxWidth: "28vw",
    maxHeight: 42,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  productImage: {
    display: "flex",
    alignItems: "center",
    marginRight: theme.spacing(2),
  },
  remainingTimeWrapper: {
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(0.5),
    alignSelf: "flex-end",
  },
  remainingTimeWrapperText: {
    color: grey[500],
    marginRight: theme.spacing(-6.25),
    fontSize: "12px",
  },
  remainingTimeIcon: {
    fontSize: 14,
    marginRight: theme.spacing(0.5),
    color: grey[500],
  },
  productContent: {
    width: "100%",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    background: "transparent",
    flexDirection: "column",
    padding: theme.spacing(0.5, 0),
  },
  productMainInfo: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  productActions: {
    display: "flex",
    alignItems: "center",
  },
  productRemove: {
    width: theme.spacing(6),
    marginLeft: theme.spacing(2),
    flexShrink: 0,
  },
  warning: {
    margin: theme.spacing(2, 8, 0, 0),
  },
  supplerProductsContainer: {
    padding: theme.spacing(0, 3),
    position: "relative",
    paddingBottom: theme.spacing(3),
    borderBottom: `1px solid ${grey[300]}`,
    marginBottom: theme.spacing(3),
  },
  lastSupplerProductsContainer: {
    borderBottomWidth: 0,
    marginBottom: 0,
    paddingBottom: 0,
  },
  productRequireApprovalAlert: {
    marginTop: theme.spacing(3),
  },
  tooltipText: {
    fontSize: "10px",
  },
  infoIcon: {
    width: 20,
    height: 20,
    verticalAlign: "middle",
    marginBottom: theme.spacing(0.25),
    color: theme.palette.primary.main,
    marginLeft: theme.spacing(0.75),
  },
  purchaseLimitIcon: {
    color: theme.palette.warning.main,
    width: 16,
    height: 16,
  },
  purchaseLimitLabel: {
    color: theme.palette.warning.main,
    textTransform: "capitalize",
    letterSpacing: "6%",
  },
  form: {
    color: theme.palette.contrastText.main,
  },
}));
